import axios from "../plugins/parseAxios";
export class PostAPI {
  constructor(props) { }
  static createPost(payload) {
    return axios.post("functions/createPost", payload);
  }
  static editPost(payload) {
    return axios.post("functions/editPost", payload)
  }
  static getPosts(payload) {
    return axios.post("functions/getPosts", payload)
  }
  static getPost(id) {
    return axios.post("functions/getPost", { id });
  }
  static getSeenPostUser(id) {
    return axios.post("functions/getSeenPostUser", { id });
  }
  static removedPost(id) {
    return axios.post("functions/removedPost", {id});
  }
}
